import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'components/NumberFormat'
import {
  TooltipTable,
  TooltipRow,
  TooltipCell
} from 'components/Tooltip'
import Icon from 'components/Icon'
import WithTooltip from 'components/WithTooltip'

export default class OrderItems extends React.Component {
  static propTypes = {
    items: PropTypes.array
  }

  render() {
    const {items} = this.props

    if (items.length) {
      return (
        <WithTooltip title={this.renderTooltip()}>
          <div className='orders-view_orders-table-items'>
            <Icon name='order' size='13px' />
            <span className='orders-view_orders-table-items_count'>
              {items.length}
            </span>
          </div>
        </WithTooltip>
      )
    } else {
      return <span>-</span>
    }
  }

  renderTooltip() {
    const {items} = this.props
    if (!items || items.length === 0) return null

    return (
      <TooltipTable className='orders-view_orders-table-items_tooltip'>
        <TooltipRow>
          <TooltipCell>Name</TooltipCell>
          <TooltipCell>Price</TooltipCell>
          <TooltipCell>Quantity</TooltipCell>
        </TooltipRow>
        {items.map(this.renderItem)}
      </TooltipTable>
    )
  }

  renderItem = (item, index) => {
    const {name, price, currency, quantity} = item
    return (
      <TooltipRow key={index} color='white'>
        <TooltipCell>{name}</TooltipCell>
        <TooltipCell>
          <NumberFormat
            value={price}
            format='currency'
            currency={currency}
          />
        </TooltipCell>
        <TooltipCell>{quantity}</TooltipCell>
      </TooltipRow>
    )
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/OrderItems.js